var _path, _path2, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilterNsfw = function SvgIconFilterNsfw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616879",
    d: "M12 17.84c-2.39 0-4.33-1.72-4.33-3.84s1.94-3.84 4.33-3.84 4.33 1.72 4.33 3.84-1.94 3.84-4.33 3.84m0-6.35c-1.56 0-2.83 1.126-2.83 2.51s1.27 2.51 2.83 2.51 2.83-1.126 2.83-2.51-1.27-2.51-2.83-2.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#616879",
    d: "M12 22c-3.76 0-7.31-1.951-9.75-5.34-1.06-1.463-1.06-3.848 0-5.32C4.7 7.95 8.25 6 12 6s7.3 1.951 9.74 5.34c1.06 1.463 1.06 3.848 0 5.32C19.3 20.05 15.75 22 12 22m0-14.67c-3.23 0-6.32 1.721-8.48 4.728-.75 1.037-.75 2.847 0 3.884C5.68 18.95 8.77 20.67 12 20.67s6.32-1.721 8.48-4.728c.75-1.037.75-2.847 0-3.884C18.32 9.05 15.23 7.33 12 7.33"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 6,
    r: 5.5,
    fill: "#E62828",
    stroke: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#icon_filter_nsfw_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 3.6v1.8c0 .72-.12 1.4-.4 2.04q-.12.24-.36.24c-.04 0-.12 0-.16-.04-.2-.08-.32-.32-.24-.52.24-.52.36-1.12.36-1.72V3.88L20 2.84l-1.56.68c-.2.08-.44 0-.52-.2s0-.44.2-.52l1.72-.72c.12-.04.2-.04.32 0l2.8 1.2c.16 0 .24.16.24.32M16.68 2.92l6.4 6.4c.16.16.16.4 0 .56-.08.08-.16.12-.28.12s-.2-.04-.28-.12l-.76-.76c-.24.28-.52.52-.8.72s-.6.28-.92.28-.64-.12-.92-.28a5.6 5.6 0 0 1-1.68-1.92 5.4 5.4 0 0 1-.6-2.48V4.32c0-.04 0-.08.04-.12l-.72-.72a.387.387 0 0 1 0-.56c.16-.16.36-.16.52 0m.92 2.48c0 .72.16 1.48.52 2.12.32.64.84 1.24 1.44 1.64.28.2.64.2.92 0 .24-.16.48-.4.72-.64l-3.6-3.56z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_filter_nsfw_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.8 1.2h-9.6v9.6h9.6z"
  })))));
};
export default SvgIconFilterNsfw;